/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import { Box } from '@mui/material'
import { ChevronRight } from '@mui/icons-material'
import { ContentBlock } from '../types/guide.types'

const containerStyle = css({
  marginTop: '1rem',
})

const linkBoxStyle = css`
  display: flex;
  color: #006fabff;
  font-weight: 700;
  &:hover {
    color: #004d7a;
  }
`

const ArticleReferenceBlock: React.FC<ContentBlock> = ({ id, Label, Url }) => {
  return (
    <Box key={id} css={containerStyle}>
      <li key={id}>{Label}</li>
      {Url && (
        <a href={Url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
          <Box css={linkBoxStyle}>
            <span>Read more</span>
            <ChevronRight />
          </Box>
        </a>
      )}
    </Box>
  )
}

export default ArticleReferenceBlock
